<template>
    <div id="festivalModel">
        <headers title="选择内容"></headers>
        <div class="fixed_top" @click="setFestival()">
            <span>自定义</span><img src="../img/diy_add.png" alt="">
        </div>
        <div class="model_list">
            <div class="model_text" @click="setFestival(no)" v-for="no in numList" :key="no">{{no}}一到来，再想一回那放飞的红晴蜓，那会眨眼的小星星，那储存宝贝的玻璃瓶，那独一无二的快乐和纯真吧。给疲惫的心放个假，儿童节快乐!</div>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
    import headers from 'COMPONENTS/base/header.vue'
    export default {
        components: {
            headers
        },
        data() {
            return {
                numList:["一","二","三","四","五","六","七"]
            }
        },
        created() {
        
        },
        methods: {
            setFestival(no){
                let str = no ? "&festival=" + encodeURIComponent(no) : "";
                this.$router.push("/reminder/send?type=3"+str);
            }
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .fixed_top{
        position: fixed;
        top: 96px/$ppr;
        left: 0;
        width: 100%;
        height: 212px/$ppr;
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        background-image: url("../img/border_icon.png");
        background-size: 672px/$ppr 132px/$ppr;
        background-position: center;
        background-repeat: no-repeat;
        font-size: 30px/$ppr;
        color: #999;
        span,img{
            display: block;
        }
        img{
            width: 40px/$ppr;
            margin-left: 26px/$ppr;
        }
    }
    .model_list{
        padding: 236px/$ppr 24px/$ppr 0;
        .model_text{
            background-color: #fff;
            border-radius: 16px/$ppr;
            padding: 28px/$ppr 24px/$ppr;
            font-size: 30px/$ppr;
            line-height: 50px/$ppr;
            margin-bottom: 24px/$ppr;
        }
    }
</style>